import { Injectable } from '@angular/core';
import { OauthAdapter } from './oauth.adapter';

@Injectable({
  providedIn: 'root',
})
export class ACMAdapter extends OauthAdapter {
  protected provider = 'acm';

  constructor() {
    super();
  }
}

